import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const RecommendationEmptyState = ({ title = 'No recommendations yet', children }) => (
  <div className="rounded-lg border border-dashed border-slate-200 bg-white p-6 text-center">
    <SafeIcon icon={FiIcons.FiBookOpen} className="mx-auto h-8 w-8 text-slate-300" />
    <h3 className="mt-3 text-sm font-bold text-slate-900">{title}</h3>
    <p className="mx-auto mt-1 max-w-xl text-sm leading-relaxed text-slate-500">
      {children || 'As more intake answers are completed, relevant learning topics and resources may appear here.'}
    </p>
  </div>
);

export default RecommendationEmptyState;
